import { Contact } from './contact'

export { Contact }
